export var UsFlField;
(function (UsFlField) {
    UsFlField["VERSION"] = "Version";
    UsFlField["PROCESSING_NOTICE"] = "ProcessingNotice";
    UsFlField["SALE_OPT_OUT_NOTICE"] = "SaleOptOutNotice";
    UsFlField["TARGETED_ADVERTISING_OPT_OUT_NOTICE"] = "TargetedAdvertisingOptOutNotice";
    UsFlField["SALE_OPT_OUT"] = "SaleOptOut";
    UsFlField["TARGETED_ADVERTISING_OPT_OUT"] = "TargetedAdvertisingOptOut";
    UsFlField["SENSITIVE_DATA_PROCESSING"] = "SensitiveDataProcessing";
    UsFlField["KNOWN_CHILD_SENSITIVE_DATA_CONSENTS"] = "KnownChildSensitiveDataConsents";
    UsFlField["ADDITIONAL_DATA_PROCESSING_CONSENT"] = "AdditionalDataProcessingConsent";
    UsFlField["MSPA_COVERED_TRANSACTION"] = "MspaCoveredTransaction";
    UsFlField["MSPA_OPT_OUT_OPTION_MODE"] = "MspaOptOutOptionMode";
    UsFlField["MSPA_SERVICE_PROVIDER_MODE"] = "MspaServiceProviderMode";
})(UsFlField || (UsFlField = {}));
export const USFL_CORE_SEGMENT_FIELD_NAMES = [
    UsFlField.VERSION,
    UsFlField.PROCESSING_NOTICE,
    UsFlField.SALE_OPT_OUT_NOTICE,
    UsFlField.TARGETED_ADVERTISING_OPT_OUT_NOTICE,
    UsFlField.SALE_OPT_OUT,
    UsFlField.TARGETED_ADVERTISING_OPT_OUT,
    UsFlField.SENSITIVE_DATA_PROCESSING,
    UsFlField.KNOWN_CHILD_SENSITIVE_DATA_CONSENTS,
    UsFlField.ADDITIONAL_DATA_PROCESSING_CONSENT,
    UsFlField.MSPA_COVERED_TRANSACTION,
    UsFlField.MSPA_OPT_OUT_OPTION_MODE,
    UsFlField.MSPA_SERVICE_PROVIDER_MODE,
];
